import BackendClient from '../backend-client';
import User, { modelFactory } from './model';
import {
  BaseModel,
} from '../models';

const ALLOWED_UPDATE_FIELDS = ['alt_phone', 'email_address', 'fax_phone', 'location', 'phone_number', 'room_location',
  'ztelefono_preferente', 'ztelefono_agescon', 'zpermitir_whatsapp', 'zid_rel_loc_edificio', 'zid_rel_planta_sala', 'zid_rel_loc_planta'];
export default class UserClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  async update(data, user) {
    try {
      const response = await this.request('put')(
        {
          ...data,
          userid: user,
        },
        {
          path: 'user',
          headers: {
            'X-Obj-Attrs': ALLOWED_UPDATE_FIELDS.join(','),
          },
        },
      );
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  getTicketActuators(ticketId) {
    return this.req({}, { resourceName: 'ticket_actuators', params: { ticket: ticketId } });
  }

  async requestUser(dmsas) {
    try {
      const response = await this.request('get')(
        {
          dmsas,
          BackEnd: 'passwordReset',
        },
        {
          path: 'public/cnt/',
        },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async getUserFromSession(session) {
    try {
      const response = await this.request('get', `U'${session.user.id}'`)(null, {
        headers: {
          'X-Obj-Attrs': ALLOWED_UPDATE_FIELDS.join(','),
        },
      });
      const cnt = response.data && response.data.cnt ? response.data.cnt : {};
      if (cnt.zid_rel_planta_sala) {
        cnt.sala = new BaseModel(cnt.zid_rel_planta_sala) || null;
      }
      if (cnt.zid_rel_loc_edificio) {
        cnt.edificio = new BaseModel(cnt.zid_rel_loc_edificio) || null;
      }
      if (cnt.zid_rel_loc_planta) {
        cnt.planta = new BaseModel(cnt.zid_rel_loc_planta) || null;
      }

      return cnt;
    } catch (error) {
      return error.response;
    }
  }

  getuserFromPhoneSMS = async (data) => {
    const { phone } = data;
    try {
      const response = await this.request('get')(
        {
          ...data,
        },
        { path: `/user/phone/${ phone }` },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  getUserCustomer = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'user/customer' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  getFechaPassCaduca= async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'user/passCaduca' },
      );
      return response.data.fechaCaducidadContrasena;
    } catch (error) {
      return error.response;
    }
  }

  getTamanoCorreo= async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'user/correoCorporativo' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  getUserOrganization = async (idTicket, persid) => {
    try {
      const response = await this.request('get')(
        { persid },
        { path: `user/organization/${ idTicket }` },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }
}
export {
  User,
};
